<template>
    <div class="quality-main-page" v-if="qualityPage != null">
        <qualityMain></qualityMain>
        <qualityEx></qualityEx>
        <qualityCards></qualityCards>
        <formPage></formPage>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import store from '@/store.js'
    import qualityMain from '@/components/quality/quality-main.vue'
    import qualityEx from '@/components/quality/quality-ex.vue'
    import qualityCards from '@/components/quality/quality-cards.vue'
	import formPage from '@/components/forms/form-page.vue';	
    export default {
        name: 'quality--page',
        components: {
            qualityMain,
            qualityEx,
            qualityCards,
            formPage,
        },
        data () {
            return {
                title: 'Качество',
            }
        },
        computed: mapGetters({
            qualityPage: 'loadQualityPage',
        }),
        methods: {
        },
        beforeRouteEnter (to, from, next) {
            if (store.state.qualityPage != null) {
                next(vm => {
                    vm.$store.commit('removePageLoaderImg');
                    setTimeout(() => {
                        vm.$parent.$refs.topProgress.done();
                    }, 100);
                });
            } else {
                store.dispatch('getQualityPageData').then((response) => {
                    if (response) {
                        next(vm => {
                            vm.$store.commit('removePageLoaderImg');
                            setTimeout(() => {
                                vm.$parent.$refs.topProgress.done();
                            }, 100);
                        });
                    } else {
                        next(false, vm => vm.$parent.$refs.topProgress.fail());
                    }
                });
            }
        },
        beforeCreate() {
            document.body.dataset.page = 'quality';
        },
        created () {
            document.title = this.title;
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/quality/quality-page.scss';
    @import '@/styles/components/quality/respond/respond-quality-page.scss';
    // @import '@/styles/components/quality/respond/quality-page-respond.scss';
</style>